/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IAdressInput {
    id?: string;
    name?: string;
    className: string;
    type: string;
    value: string;
    maxLength?: number;
    autoFocus?: boolean;
    additionalAddributes?: object;
    telemetryContent?: ITelemetryContent;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const AdressInput: React.FC<IAdressInput> = ({
    id,
    name,
    className,
    type,
    value,
    maxLength,
    additionalAddributes,
    autoFocus,
    telemetryContent,
    onChange
}) => {
    const payLoad = getPayloadObject('click', telemetryContent!, name!);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    /* VSI Customization - START - 03/02/21 - Mark input field as numeric field if it is for phone input */
    const isPhone = name ? name.toLowerCase() === 'phone' : undefined;
    const patternAttribute = isPhone
        ? { pattern: `^\s*\(?(020[7,8]{1}\)?[ ]?[1-9]{1}[0-9{2}[ ]?[0-9]{4})|(0[1-8]{1}[0-9]{3}\)?[ ]?[1-9]{1}[0-9]{2}[ ]?[0-9]{3})\s*$` }
        : {};
    if (isPhone) {
        return <></>;
    }

    if (name && name.toLowerCase() === 'name') {
        return <></>;
    }
    /* VSI Customization - END */
    return (
        <input
            name={name}
            id={id}
            className={`${className}__input ${className}__input-${type}`}
            type={isPhone ? 'number' : type} // VSI Customization to change input type to number for Phone
            {...patternAttribute} // VSI Customization to add just UK valid phone number
            value={value}
            maxLength={maxLength}
            {...(additionalAddributes || {})}
            {...attributes}
            onChange={onChange}
            placeholder={`${name?.toLowerCase() === 'zipcode' ? 'Postcode' : name} *`}
        />
    );
};

export default AdressInput;
